import React from "react";
import { Switch, Tooltip, Typography, Box } from "@material-ui/core";

export default function GenericLabeledSwitch({
    label = "",
    leftLabel = "Inactive",
    rightLabel = "Active",
    checked = false,
    onChange = () => {},
    tooltip = "",
}) {
    return (
        <>
            {label && (
                <Typography style={{ fontSize: 12, color: "#9b9b9b", marginBottom: 4 }}>
                    {label}
                </Typography>
            )}
            <Box display="flex" alignItems="center">
                <Typography style={{ marginRight: 8 }}>{leftLabel}</Typography>
                <Tooltip title={tooltip || `${leftLabel} / ${rightLabel}`} placement="top" arrow>
                    <span style={{ display: "inline-block" }}>
                        <Switch checked={checked} onChange={onChange} color="primary" />
                    </span>
                </Tooltip>
                <Typography style={{ marginLeft: 8 }}>{rightLabel}</Typography>
            </Box>
        </>
    );
}
